<template>
  <div>
    <headTop :head-title="boxTit">
      <div class="back" slot="private-return" @click="getBack()"><i class="icon-arrow_lift"></i></div>
    </headTop>
    <div class="detail-content">
      <div class="detail-tit">
        <p>{{detailObj.title}}</p>
      </div>
      <div class="detail-name">
        <span>发件人：<span class="red">{{formatff(detailObj.type)}}</span></span><span class="detail-time" v-if="detailObj.created_at">{{detailObj.created_at*1000 | formatDate}}</span>
      </div>
      <div class="bar"></div>
      <div class="detail-content-wrapper">
        <textarea v-model="detailObj.message" disabled></textarea>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '@/components/common/header/head'
  // import { messageResource } from '@/resource/resource'
  import {formatDate} from '@/common/js/common'
  // const ERR_OK = 0

  export default {
    name: 'detailM',
    data () {
      return {
      }
    },
    props: {
      type: {
        type: Number,
        default: 1
      },
      detailObj: {
        type: Object
      },
      boxTit: {
        type: String
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
      formatff(status) {
        let ret = ''
        switch (status) {
          case 1:
            ret = '系统公告'
            break
          case 2:
            ret = '系统消息'
            break
          case 3:
            ret = '站长消息'
            break
          default:
            break
        }
        return ret
      },
    getBack () {
      this.$emit('getback')
    }
    },
    filters: {
      formatDate(time) {
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .back
    position absolute
    top 0
    left 0
    padding-left 0.2rem
    height 0.9rem
    line-height 0.9rem
    width 0.4rem
    color #fff
    font-size $font-size-m
  .time
    font-size $font-size-m
    line-height 0.9rem
    right 0.2rem
    color #ffffff
    position absolute
    top 50%
    transform translateY(-50%)
  .detail-content
    font-size $font-size-l
    padding 0.48rem 0.28rem
    color #666666
    position absolute
    top 0.9rem
    bottom 0
    left 0
    width 100%
    background-color #fff
    box-sizing border-box
    .detail-tit
      font-size $fz-t5
      word-wrap break-word
      color $c-b1
      line-height 0.35rem
      font-weight 700
    .detail-name
      font-size $fz-t3
      line-height 0.35rem
      margin-top 0.48rem
      word-wrap break-word
      color $c-b3
      position relative
      .red
        color $c-r
        margin-right 2.3rem
      .detail-time
        position absolute
        bottom 0
        right 0
    .bar
      border-top 0.01rem solid #f4f4f4
      margin 0.3rem -0.28rem
    .detail-content-wrapper
      line-height 0.4rem
      & > textarea
        outline none
        font-size $fz-t3
        color $c-b1
        width 100%
        height 8.0rem
        border 0px
        overflow-y visible
        resize none
        background-color #fff
</style>



// WEBPACK FOOTER //
// src/components/message/detailM.vue